module.exports = __webpack_public_path__ + "static/media/mapCloud_2.9be6f9f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mapCloud_2.png
// module id = 856
// module chunks = 0